exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?{\"modules\":true,\"localIdentName\":\"[name]__[local]__[hash:base64:5]\"}!../../styles/colors.css"), undefined);
exports.i(require("-!../../../node_modules/css-loader/index.js?{\"modules\":true,\"localIdentName\":\"[name]__[local]__[hash:base64:5]\"}!../../styles/fonts.css"), undefined);

// module
exports.push([module.id, ".tableCellCharacteristic__cell__3VUlJ{display:block;position:relative}.tableCellCharacteristic__value__2XKhV{color:#000;font-family:Open Sans,helvetica,sans-serif;padding-right:25px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;width:100%}.tableCellCharacteristic__button__UC62Q{line-height:10px;position:absolute;right:2px;top:5px}", ""]);

// exports
exports.locals = {
	"black": "" + require("-!../../../node_modules/css-loader/index.js?{\"modules\":true,\"localIdentName\":\"[name]__[local]__[hash:base64:5]\"}!../../styles/colors.css").locals["black"] + "",
	"fontFamily": "" + require("-!../../../node_modules/css-loader/index.js?{\"modules\":true,\"localIdentName\":\"[name]__[local]__[hash:base64:5]\"}!../../styles/fonts.css").locals["fontFamily"] + "",
	"cell": "tableCellCharacteristic__cell__3VUlJ",
	"value": "tableCellCharacteristic__value__2XKhV",
	"button": "tableCellCharacteristic__button__UC62Q"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./app/components/tableCellCharacteristic/tableCellCharacteristic.css
// module id = 746
// module chunks = 0